import { getInvestmentProgramNames } from '@monoimin/storyblok/getInvestmentProgramNames';

import { createPageDate } from './createPageDate';
import { createPageLevel } from './createPageLevel';
import { getPersonName } from './getPersonName';
import { createCountryInfo } from './createCountryInfo';

import type {
  MethodologyStoryblok,
  PageStoryblok,
  PassportForPressStoryblok,
  PassportRatingAboutStoryblok,
  PassportRatingHomePageStoryblok,
  ProgramPageStoryblok,
  RatingsCompareStoryblok,
  RatingStoryblok,
} from '@monoimin/sb-types';

import type { AnalyticsDataCollector } from '../types';

export type PageBlokAnalytics = {
  page_level: number | string;
  page_country: string | string[];
  page_region: string | string[];
  page_program: string[];
  page_status: string;
  page_type: string;
  page_purpose: string | number;
  page_initiator: string;
  page_expert: string;
  page_author: string;
  page_language: string;
};

export const collectDataForPageBlokAnalytics: AnalyticsDataCollector<
  | PageStoryblok
  | ProgramPageStoryblok
  | PassportRatingHomePageStoryblok
  | RatingStoryblok
  | RatingsCompareStoryblok
  | PassportRatingAboutStoryblok
  | MethodologyStoryblok
  | PassportForPressStoryblok,
  PageBlokAnalytics
> = async (story, locale) => {
  const { published_at, first_published_at, content } = story;

  const {
    pageLevel,
    pageStatus = '',
    programRelation = '',
    pageProgram = '',
    pageType = '',
    pagePurpose = '',
    pageInitiator = '',
  } = content;

  const { country: pageCountry, region: pageRegion } = await createCountryInfo({
    country: content.country,
    pageCountry: content.pageCountry,
  });

  const investmentProgramNames = await getInvestmentProgramNames(pageProgram);

  const [pageAuthor, pageExpert] = await Promise.all([
    getPersonName(content.pageAuthor),
    getPersonName(content.pageExpert),
  ]);

  return {
    page_update_date: createPageDate(published_at),
    page_first_published_date: createPageDate(first_published_at),
    page_level: createPageLevel(pageLevel),
    page_country: pageCountry ?? '',
    page_region: pageRegion,
    page_program: Array.isArray(investmentProgramNames)
      ? investmentProgramNames
      : [investmentProgramNames],
    page_status: pageStatus,
    page_type: pageType,
    page_purpose: pagePurpose,
    page_initiator: String(pageInitiator),
    program_relation: programRelation,
    page_expert: pageExpert,
    page_author: pageAuthor,
    page_language: locale,
  };
};
